import { render, staticRenderFns } from "./TermsAndConditionModal.vue?vue&type=template&id=169dc4a6&"
import script from "./TermsAndConditionModal.vue?vue&type=script&lang=ts&"
export * from "./TermsAndConditionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports